import {Controller} from "@hotwired/stimulus";

export default class SubmitLoaderController extends Controller {

    static get targets() {
        return ['loader', 'showcaseLoader', 'input']
    }

    connect() {
        let btn = $(this.element).find('.submit-button').find('span').text()

        this.element.addEventListener("turbo:submit-start", (e) => {
            $(this.element).find('.submit-button').html("<span class='spinner-border spinner-border-sm'></span></div> Loading...</div> ").attr('disabled', true);
            $(this.element).find('.submit-button').attr('disabled', true)
            $(this.element).addClass('disabled-form')
        })

        this.element.addEventListener("turbo:submit-end", (e) => {
            $(this.element).find('.submit-button').html("<span class=\"text-black-border bg-text-white d-block transparent-bg-text p-font-bold text-stroke-2 -text-spacing-3 fst-italic\"> " + btn + "</span>").attr('disabled', false);
            $(this.element).find('.submit-button').attr('disabled', false)
            $(this.element).removeClass('disabled-form')
        })

        if (this.hasLoaderTarget) {
            this.element.addEventListener('click', (e) => {
                $(this.element).find("span").html("<span class='spinner-border spinner-border-sm'></span></div> Loading...</div> ");
            })
        }

        // Fixed the issue where the loader remained visible after a form submission error.
        if (this.hasShowcaseLoaderTarget) {
            const form = $(this.element);
            const btn = $(this.element).find(".showcase-submit");
            const originalHtml = btn.find("span").html();

            btn.on("click", function () {
                if (form.valid()) {
                    $(this).find("span").html(
                        "<span class='spinner-border spinner-border-sm'></span> Loading..."
                    );
                }
            });

            this.element.addEventListener("turbo:submit-end", () => {
                btn.find("span").html(originalHtml);
            });
        }
    }

    submitCardForm(e){
        // console.log("innnn")
        if (!$(this.element).valid()) {e.preventDefault()}
        
        if($('#card_id').length > 0){
            e.preventDefault()
            $(this.element)[0].requestSubmit()
        }
    }

    selectFile(e) {
        e.preventDefault()
        let target = document.querySelectorAll('[name="help_ticket[documents][]"]')[1]
        target.click()
    }

    inputTargetConnected() {
        this.inputTarget.addEventListener("input", () => {
            this.element.querySelector('.submit-button').removeAttribute('disabled')
            this.element.querySelector('.submit-button').classList.remove('disabled')
        })
    }
}